
import { defineComponent } from 'vue';
import {
  message, Upload, Icon, Modal, Button,
} from 'ant-design-vue';
import VueCropper, { VueCropperMethods } from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default defineComponent({
  name: 'CaseUploadImg',
  props: {
    disabled: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    urlsrc: {
      type: String,
    },
    aspectRatio: {
      type: Number,
      default: 16 / 9,
    },
    text: {
      type: String,
      default: '210*118',
    },
    nocut: { // 不裁切，直接上传原文件
      type: Boolean,
      default: false,
    },
  },
  components: {
    VueCropper,
    aUpload: Upload,
    aModal: Modal,
    aButton: Button,
    aIcon: Icon,
  },
  data() {
    return {
      loading: false,
      imgSrc: '',
      path: '',
      modalVisible: false,
    };
  },
  watch: {
    urlsrc() {
      this.path = '';
    },
  },
  methods: {
    // eslint-disable-next-line consistent-return
    beforeUpload(file: File) {
      const arr = ['image/png', 'image/jpeg'];
      if (file.size > 2048000) {
        return message.error('图片大小需在2M内');
      }
      if (!arr.includes(file.type)) {
        return message.error('请上传正确格式图片');
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event: Event) => {
          this.imgSrc = (event.target as FileReader).result as string;
          if (!this.nocut) {
            this.modalVisible = true;
            this.$nextTick(() => {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (this.$refs.cropper as unknown as VueCropperMethods).replace((event.target as any).result);
            });
          } else {
            this.$emit('upload', file);
          }
        };
        return reader.readAsDataURL(file);
      }
    },
    onOk() {
      console.log('ok');
      return new Promise((resolve, reject) => {
        try {
          this.loading = true;
          this.path = (this.$refs.cropper as unknown as VueCropperMethods)
            .getCroppedCanvas()
            .toDataURL();
          (this.$refs.cropper as unknown as VueCropperMethods)
            .getCroppedCanvas()
            .toBlob((blob: Blob|null) => {
              console.log(blob);
              if (blob) {
                const files = new window.File([blob], '案例封面.png', {
                  type: 'image/png',
                });
                this.$emit('upload', files);
                // this.formData.append("image", files);
                this.modalVisible = false;
                resolve(files);
              } else {
                reject();
              }
            });
        } catch (error) {
          console.error(error);
          reject(error);
        } finally {
          this.loading = false;
        }
      });
    },
    onCancel() {
      this.imgSrc = '';
      this.modalVisible = false;
    },
  },
});
